import theme from '../../theme/theme';

const {
  colors: { subtitle, mp_flag, minute, black_text },
} = theme;

const styles = {
  header__container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    paddingBottom: '1.425em',
  },

  title: {
    fontFamily: 'semibold',
    fontSize: '2em',
    color: black_text,
    fontWeight: 600,
    paddingLeft: '2em',
    paddingRight: '2em',
    wordBreak: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  mp: {
    color: mp_flag,
    fontSize: '20px',
    paddingLeft: '.5em',
  },

  subtitle: {
    fontSize: '1.250em',
    fontWeight: 'normal',
    color: subtitle,
    letterSpacing: '-0.031em',
    paddingLeft: '2em',
    paddingRight: '2em',
  },

  time__container: {
    justifyContent: 'center',
    display: 'flex',
    paddingBottom: '1.6em',
    paddingLeft: '6.250em',
    paddingRight: '6.250em',
  },

  min: {
    fontFamily: 'semibold',
    fontSize: '1.5em',
    fontWeight: 600,
    color: minute,
    alignContent: 'center',
    letterSpacing: '-0.031em',
  },

  mile: {
    fontFamily: 'semibold',
    fontSize: '1.5em',
    color: black_text,
    fontWeight: 600,
    letterSpacing: '-0.031em',
  },

  dot: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    fontFamily: 'bold',
    color: subtitle,
    fontWeight: 'bold',
    fontSize: '1em',
    paddingLeft: '1.188em',
    paddingRight: '1.188em',
  },
};

export default styles;
